<template>
  <div class="ft-sa-grid-container p-4">
    <div class="ft-sa-grid-left">
      <div>
        <div class="ft-sa-table-header" :style="{ '--grid-columns': gridTemplateColumnsIva }">
          <div class="sa-ft-label text-left">#</div>
          <div class="sa-ft-label text-left">
            🧾 IVA
          </div>
          <div class="sa-ft-label text-center">
            📊 Aliquota
          </div>
          <div class="sa-ft-label text-center">
            💰 Imponibile
          </div>
          <div class="sa-ft-label text-center">
            🧮 Imposta
          </div>
        </div>
        <div class="ft-sa-rows-viewport">
          <template v-if="ivaRighe.length > 0">
            <div class="ft-sa-row-card" v-for="(riga, i) in ivaRighe" :key="i">
              <div class="ft-sa-row-content" :style="{ '--grid-columns': gridTemplateColumnsIva }">
                <div>{{ i + 1 }}</div>
                <div class="text-left" style="font-size: smaller; font-weight: 700;">{{ riga.descrizioneIva }}</div>
                <div class="text-center sa-ft-money">{{ riga.aliquotaIva.toLocaleString("it-IT", {
                  style: "currency",
                  currency: "EUR"
                }) }}</div>
                <div class="text-right sa-ft-money">{{ riga.imponibileIva.toLocaleString("it-IT", {
                  style: "currency",
                  currency: "EUR"
                }) }}</div>
                <div class="text-right sa-ft-money">{{ riga.impostaIva.toLocaleString("it-IT", {
                  style: "currency",
                  currency: "EUR"
                }) }}</div>
              </div>
            </div>
          </template>
          <div v-else class="ft-sa-rows-viewport d-flex align-items-center justify-content-center">
            <NoDataComponent :title="'Non sono presenti righe Iva'" :fontSize="15" />
          </div>
        </div>
      </div>
    </div>
    <div class="ft-sa-grid-right">
      <div>
        <div class="ft-sa-table-header" :style="{ '--grid-columns': gridTemplateColumnsPagamenti }">
          <div class="sa-ft-label">#</div>
          <div class="sa-ft-label">
            📊 Descrizione
          </div>
          <div class="sa-ft-label text-center">
            🧾 Stato
          </div>
          <div class="sa-ft-label text-right">
            💰 Importo
          </div>
        </div>
        <div class="ft-sa-rows-viewport">
          <template v-if="ivaRighe.length > 0">
            <div class="ft-sa-row-card" v-for="(riga, i) in pagamentiRighe" :key="i">
              <div class="ft-sa-row-content" :style="{ '--grid-columns': gridTemplateColumnsPagamenti }">
                <div class="text-left">{{ i + 1 }}</div>
                <div class="text-left">
                  <strong v-if="riga.descrizione.includes('{numerodoc}')">{{
                    riga.descrizione.replace("{numerodoc}", "") }}</strong>
                  <strong v-else>{{ riga.descrizione }}</strong>
                </div>
                <div class="text-center">
                  <b-badge pill
                    :variant="riga.stato == 'NON PAGATO' ? 'danger' : riga.stato == 'PAGATO' ? 'success' : 'warning'">
                    <strong>{{ riga.stato }}</strong></b-badge>
                </div>
                <div class="text-right sa-ft-money">{{ riga.importoScadenza.toLocaleString("it-IT", {
                  style: "currency",
                  currency: "EUR"
                }) }}</div>
              </div>
            </div>
          </template>
          <div v-else class="ft-sa-rows-viewport d-flex align-items-center justify-content-center">
            <NoDataComponent :title="'Non sono presenti righe Pagamenti'" :fontSize="15" />
          </div>
        </div>
      </div>
    </div>
  </div>






  <!-- <div class="sa-list-component">
    <div class="sa-list-component-body">
      <div class="b-table-sticky-header">
        <b-row>
          <b-col cols="6">
            <label class="sa-label-data">Tabella Riferimento Iva</label>
            <b-table sticky-header ref="table" stacked="xl" striped hover :items="ivaRighe" :fields="ivaFields"
              :current-page="1" :per-page="1000" sort-icon-left head-variant="light" class="sa-b-table">
              <template #cell(index)="row">
                {{ (currentPage - 1) * perPage + row.index + 1 }}
              </template>

<template #cell(imponibileIva)="row">
                <strong> {{ row.item.imponibileIva.toLocaleString("it-IT", { style: "currency", currency: "EUR" })
                  }}</strong>
              </template>
</b-table>
</b-col>
<b-col cols="6">
  <label class="sa-label-data">Tabella Riferimento Pagamenti</label>
  <b-table sticky-header ref="table" stacked="xl" striped hover :items="pagamentiRighe" :fields="pagamentiFields"
    :current-page="1" :per-page="1000" sort-icon-left head-variant="light" class="sa-b-table">
    <template #cell(index)="row">
                {{ (currentPage - 1) * perPage + row.index + 1 }}
              </template>
    <template #cell(descrizione)="row">
                <strong v-if="row.item.descrizione.includes('{numerodoc}')">{{
                  row.item.descrizione.replace("{numerodoc}", "") }}</strong>
                <strong v-else>{{ row.item.descrizione }}</strong>
              </template>
    <template #cell(stato)="row">
                <b-badge pill
                  :variant="row.item.stato == 'NON PAGATO' ? 'danger' : row.item.stato == 'PAGATO' ? 'success' : 'warning'">
                  <strong>{{ row.item.stato }}</strong></b-badge>
              </template>
  </b-table>
</b-col>
</b-row>
</div>
</div>
</div> -->
</template>
<script>
import moment from "moment";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
export default {
  data() {
    return {
      pagamentiRighe: [],
      pagamentiFields: [
        {
          key: "importoScadenza",
          label: "Importo",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            }
            return value;
          },
        },
        {
          key: "descrizione",
          label: "Descrizione",
        },

        {
          key: "dataScadenza",
          label: "Scadenza",
          formatter: (value) => {
            return moment(new Date(value)).format("DD-MMM-YYYY");
          },
        },
        {
          key: "stato",
          label: "Stato",
        },
      ],
      ivaRighe: [],
      ivaFields: [
        {
          key: "descrizioneIva",
          label: "Iva",
        },
        {
          key: "aliquotaIva",
          label: "Alq.",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "percent" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "percent" });
            }
            if (value > 0 && value <= 1) {
              value = value * 100;
              value = value.toLocaleString("it-IT", { style: "percent" });
            }

            return value;
          },
        },
        {
          key: "codiceIva",
          label: "Codice Iva",
        },
        {
          key: "impostaIva",
          label: "Imposta",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            }
            return value;
          },
        },
        {
          key: "imponibileIva",
          label: "Imponibile",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            }
            return value;
          },
        },
      ],
    };
  },
  components: { NoDataComponent },
  computed: {
    gridTemplateColumnsIva() {
      const cols = [];
      cols.push("20px");
      cols.push("1fr");
      cols.push("80px");
      cols.push("80px");
      cols.push("80px");
      return cols.join(" ");
    },
    gridTemplateColumnsPagamenti() {
      const cols = [];
      cols.push("20px");
      cols.push("1fr");
      cols.push("100px");
      cols.push("100px");
      return cols.join(" ");
    },
  },
  methods: {
    init(jsonData) {
      this.ivaRighe = jsonData.righeDocumentoIva;
      this.pagamentiRighe = jsonData.righePagamenti;
    },


  },
};
</script>

<style scoped>
.ft-sa-doc-container {
  font-family: 'Inter', -apple-system, sans-serif;
  background: white;
  padding: 26px;
  padding-top: 10px !important;
  color: var(--text-main);
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100% !important;
}

.sa-ft-money {
  font-variant-numeric: tabular-nums !important;
  font-weight: 600 !important;
  text-align: center !important;
  color: #64748b !important;
}


/*
|--------------------------------------------------------------------------
| GRID SHARED
|--------------------------------------------------------------------------
*/

.ft-sa-table-header,
.ft-sa-row-content {
  display: grid;
  grid-template-columns: var(--grid-columns);
  align-items: center;
}

.ft-sa-table-header {
  padding: 12px 30px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--primary);
  flex-shrink: 0;
  background: #f8fafc;
  border-bottom: 1px solid var(--border-color);
  border-radius: 12px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.sa-ft-riferimento-doc {
  display: flex;
  justify-content: center;
  padding: 3px;
}


.ft-sa-rows-viewport {
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px 5px;
  margin-bottom: 10px;
  max-height: 400px;
  padding-bottom: 20px;
}

.ft-sa-rows-viewport::-webkit-scrollbar {
  width: 6px;
}

.ft-sa-rows-viewport::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.ft-sa-row-card {
  background: white;
  border-radius: 12px;
  margin-bottom: 12px;
  transition: all 0.25s ease;
  border: 1px solid #edf2f7;
  position: relative;
  overflow: hidden;
  border-left: 4px solid var(--bg-sidebar-item);
}

.ft-sa-row-card:hover {
  transform: translateY(-2px);
  border-color: var(--primary);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.ft-sa-row-content {
  padding: 10px 16px;
}

.ft-sa-table-footer {
  padding-top: 10px;
  display: flex;
  justify-content: center;
}

.ft-sa-add-row-placeholder {
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 20px;
  text-align: center;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
  background: #f8fafc;
  width: 100%;
  max-width: 400px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ft-sa-add-row-placeholder:hover:not(:disabled) {
  background: white;
  border-color: var(--primary);
  color: var(--primary);
  transform: translateY(-1px);
}

.ft-sa-add-row-placeholder:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ft-sa-grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  height: 100%;
}
</style>
